import type { Prisma } from "@prisma/client";

export const humanProcessingStatuses = [
  "TO_BE_PROCESSED",
  "COMPLIANT",
  "NON_COMPLIANT",
] as const;

export const humanProcessingStatusLabels = {
  TO_BE_PROCESSED: "À traiter",
  COMPLIANT: "Conforme",
  NON_COMPLIANT: "Non Conforme",
} as const;

export const humanProcessingStatusDropdownClassMap = {
  TO_BE_PROCESSED: "border-2 font-bold text-orange-badge-text border-orange-badge-border hover:bg-orange-badge-background hover:text-orange-badge-text",
  COMPLIANT: "border-2 font-bold text-green-badge-text border-green-badge-border hover:bg-green-badge-background hover:text-green-badge-text",
  NON_COMPLIANT: "border-2 font-bold text-red-badge-text border-red-badge-border hover:bg-red-badge-background hover:text-red-badge-text"
} as const;

export const humanProcessingStatusChipColorClassMap = {
  TO_BE_PROCESSED: "orange",
  COMPLIANT: "green",
  NON_COMPLIANT: "red",
} as const;

export const fileOnSocietyTypes = [
  "KBIS",
  "IDENTITY",
  "RIB",
  "RC",
  "GUARANTEE",
  "ORIAS",
  "LCB",
  "LOGO",
  "CONVENTION",
  "CONVENTION_SIGNED",
  "OTHER",
] as const;

export const fileAbilityControlSelect = {
  authorId: true,
  bucket: true,
  societies: {
    select: {
      societyId: true,
    }
  },
  constructionSites: {
    select: {
      ConstructionSite: {
        select: {
          brokerSocietyId: true,
        }
      }
    }
  },
  constructionSiteSubmissions: {
    select: {
      constructionSiteSubmission: {
        select: {
          constructionSite: {
            select: {
              brokerSocietyId: true
            }
          }
        }
      }
    }
  },
  folder: {
    select: {
      constructionSiteSubmission: {
        select: {
          constructionSite: {
            select: {
              brokerSocietyId: true
            }
          }
        }
      }
    }
  }
} satisfies Prisma.FileSelect;

export const fileWithMetadataSelector = {
  id: true,
  name: true,
  bucket: true,
  key: true,
  mimeType: true,
  size: true,
  humanProcessingStatus: true,
  processingJobs: {
    select: {
      id: true,
      type: true,
      status: true,
      createdAt: true,
      startedAt: true,
      completedAt: true,
    }
  },
  fileData: {
    select: {
      type: true,
      issuer: true,
      metadata: true,
      mutableMetadata: true,
      comment: true,
    }
  }
} satisfies Prisma.FileSelect;


export const basicFileSelector = {
  id: true,
  name: true,
  key: true,
  size: true,
  humanProcessingStatus: true,
  fileData: {
    select: {
      type: true
    }
  }
} satisfies Prisma.FileSelect;
